import { useMutation } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { ApiError, FeatureToggleEvaluateResponse } from '../types/showcase';

/** C020 기능 토글 데모(read-only) — GET .../feature-toggle/evaluate?key= (queue #646 §R646-2). */
export function useFeatureToggleEvaluate() {
  return useMutation<FeatureToggleEvaluateResponse, ApiError, string>({
    mutationFn: (key) => showcaseApi.featureToggleEvaluate(key),
    mutationKey: ['common-showcase', 'feature-toggle', 'evaluate'],
  });
}
